module.exports = __webpack_public_path__ + "static/media/aws-ai.75a46977.png";